/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useEffect } from "react";
import { FiGift } from "react-icons/fi";

const splitGiftImages = (value) =>
  String(value || "")
    .split(/[;,]/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, 8);

const imageUrl = (baseUrl, path) => {
  const value = String(path || "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `${baseUrl}${value.replace(/^\/+/, "")}`;
};

const GiftBubbleOverlay = ({ animation, imageBaseURL, onDone }) => {
  const giftImages = splitGiftImages(animation?.giftImg);
  const isReceived = animation?.type === "received";
  const earning = Number(animation?.earning || 0);
  const amountLabel = isReceived && earning > 0
    ? `Earned ${animation?.currency || ""}${earning}`
    : animation?.coin
      ? `${animation.coin} coins`
      : "A little surprise is flying.";

  useEffect(() => {
    const timer = window.setTimeout(onDone, 2800);
    return () => window.clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden">
      <style>
        {`
          @keyframes gomeetGiftFloat {
            0% { transform: translate3d(0, 80px, 0) scale(.72); opacity: 0; }
            12% { opacity: 1; }
            72% { opacity: 1; }
            100% { transform: translate3d(var(--gift-x), -86vh, 0) scale(1.18); opacity: 0; }
          }
          @keyframes gomeetGiftCard {
            0% { transform: translate(-50%, 18px) scale(.92); opacity: 0; }
            12% { transform: translate(-50%, 0) scale(1); opacity: 1; }
            82% { transform: translate(-50%, 0) scale(1); opacity: 1; }
            100% { transform: translate(-50%, -10px) scale(.96); opacity: 0; }
          }
        `}
      </style>

      <div
        className="absolute left-1/2 bottom-[9%] bg-white rounded-[10px] shadow-xl px-[18px] py-[12px] flex items-center gap-[12px] border border-[#efdfff]"
        style={{ animation: "gomeetGiftCard 2.8s ease forwards" }}
      >
        <div className="w-[44px] h-[44px] rounded-full bg-[#f5e8ff] flex items-center justify-center">
          <FiGift className="w-[24px] h-[24px] text-[rgba(152,14,255,255)]" />
        </div>
        <div>
          <h6 className="m-0 text-[15px] font-[700]">{isReceived ? "Gift received!" : "Gift sent!"}</h6>
          <p className="m-0 text-gray-500 text-[13px]">
            {amountLabel}
          </p>
        </div>
      </div>

      {Array.from({ length: Math.max(10, giftImages.length * 3 || 10) }).map((_, index) => {
        const giftImage = giftImages[index % Math.max(giftImages.length, 1)];
        const left = 18 + ((index * 17) % 66);
        const x = ((index % 2 === 0 ? 1 : -1) * (24 + (index % 5) * 12));
        const delay = (index % 7) * 0.12;
        const size = 42 + (index % 3) * 10;

        return (
          <div
            key={`${animation?.id}-${index}`}
            className="absolute bottom-[-70px] rounded-full bg-white shadow-lg border border-[#efdfff] flex items-center justify-center"
            style={{
              left: `${left}%`,
              width: `${size}px`,
              height: `${size}px`,
              "--gift-x": `${x}px`,
              animation: `gomeetGiftFloat ${2.2 + (index % 4) * 0.18}s ease-out ${delay}s forwards`,
            }}
          >
            {giftImage ? (
              <img src={imageUrl(imageBaseURL, giftImage)} className="max-w-[62%] max-h-[62%] object-contain" alt="Gift" />
            ) : (
              <FiGift className="w-[22px] h-[22px] text-[rgba(152,14,255,255)]" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GiftBubbleOverlay;
/* jshint ignore:end */
